// NOTE: For Team City environment variables to be reachable here they need to be started
// with REACT_APP_ prefix! I.e. REACT_APP_XC_URL or REACT_APP_HOTJAR_SITE_ID.
import _ from 'lodash';
import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

export const WORKSPACES_PARAM = 'from-workspaces';
export const SKIP_ONBOARDING_PARAM = 'skip-onboarding';
export const PERIOD_PARAM = 'period';
export const CURRENCY_PARAM = 'currency';
export const MAGIX_EMAIL_PARAM = 'pemail';
export const MAGIX_SERIAL_PARAM = 'pserial';
export const MAGIX_CATEGORY_PARAM = 'pcat';
export const COUPON_ID_PARAM = 'cid';
export const XC_USER_FOUND = 'user-found';
export const PRODUCT_NAME_PARAM = 'prod';
export const PRODUCT_LANGUAGE_PARAM = 'lang';
export const EXTERNAL_REDIRECT_PARAM = 'external-redirect';
export const INTERNAL_REDIRECT_PARAM = 'internal-redirect';
export const REACTIVATE_PARAM = 'reactivate';
export const BACK_TO_PARAM = 'back-to-path';
export const SHOW_PATH_PARAM = 'show-path';
export const PRODUCT_QUANTITY_PARAM = 'quantity';
export const PRODUCT_SOURCE_PARAM = 'source';
export const ASK_FOR_COMPANY_PARAM = 'select-company';
export const APP_COMPANY_ID_PARAM = 'app-company-id';
export const DESKTOP_APPLICATION_PARAM = 'desktop-app';
export const UPGRADE_POPUP_PARAM = 'upgrade-popup';
export const XC_URL = process.env.REACT_APP_XC_URL;
export const HTTP_API_URL = process.env.REACT_APP_HTTP_API_URL;
export const HTTP_STATIC_RESOURCES_URL = process.env.REACT_APP_HTTP_STATIC_RESOURCES_URL;
export const SEGMENT_TOKEN = process.env.REACT_APP_SEGMENT_TOKEN;
export const SEGMENT = process.env.REACT_APP_SEGMENT;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const HOTJAR_SITE_ID = process.env.REACT_APP_HOTJAR_SITE_ID;
export const TEMP_COMP_PREFIX = 'tempcomp_';
export const PLUS_OVERVIEW_PLAN_ID = 'plus-overview';
export const PERPETUAL_OVERVIEW_PLAN_ID = 'perpetual-overview';
export const STANDARD_OVERVIEW_PLAN_ID = 'standard-overview';

import {
	IconEssential,
	IconScale,
	IconWD,
	IconDP,
	IconPGD,
	IconWDPerpetual,
	IconDPPerpetual,
	IconPGDPerpetual,
	IconAddonAI,
	IconAddonCloudStorage,
	IconAddonDesignServices,
	IconAddonMLS,
	IconAddonHosting
} from 'theme/icons';

export const COUNTRY_DETECTION_ENDPOINT = '/account/country';
export const ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT = '/account/externalid';

export const HOSTING_BUTTON_URL_EN = 'https://www.xara.com/hosting/';
export const HOSTING_BUTTON_URL_DE = 'https://www.xara.com/de/hosting/';

export const CB_LIBRARY_SUPPORT_ARTICLE_EN = 'https://helpandsupport.xara.com/index.htm?rhcsh=1&rhmapno=1027';
export const CB_LIBRARY_SUPPORT_ARTICLE_DE = 'https://helpandsupport.xara.com/deu/index.htm?rhcsh=1&rhmapno=1027';

export const SEND_CURRENT_OFFERS_URL = process.env.REACT_APP_SEND_CURRENT_OFFERS_URL;
export const INTERCOM_WORKSPACE_ID = process.env.REACT_APP_INTERCOM_WORKSPACE_ID;


/* AUTH */
export const AUTHENTICATION = {
	SIGN_IN_URL: '/auth/xara-basic',
	SIGN_UP_URL: '/xara-basic',
	RESET_PASSWORD_URL: '/xara-basic/password'
};

/* CRS */
export const CRS = {
	INFO_URL: process.env.REACT_APP_CRS_INFO_URL,
	USAGE_URL: process.env.REACT_APP_CRS_USAGE_URL
};

/* CONTACT SALES */
export const CONTACT_SALES = {
	CALENDLY_LINK: process.env.REACT_APP_CONTACT_SALES_CALENDLY_LINK,
	API_ENDPOINT: process.env.REACT_APP_CONTACT_SALES_API_ENDPOINT
};

/* ACCOUNT */
export const ACCOUNT_SETTINGS = {
	minPasswordLength: 8,
	maxPasswordLength: 72
};

// USER ROLES / PERMISSION LEVEL
export const USER_ROLE_ADMIN = 'admin';
export const USER_ROLE_BASIC = 'basic';
export const USER_ROLE_GUEST = 'guest';

export const USER_ROLES = {
	[USER_ROLE_ADMIN]: {
		label: localize('config-user-roles-admin'),
		trackingName: USER_ROLE_ADMIN
	},
	[USER_ROLE_BASIC]: {
		label: localize('config-user-roles-member'),
		trackingName: USER_ROLE_BASIC
	},
	[USER_ROLE_GUEST]: {
		label: localize('config-user-roles-guest'),
		trackingName: USER_ROLE_GUEST
	},
};

export const CURRENCIES = {
	USD: { key: 'usd', value: localize('subscription-currency-usd'), symbol: '$' },
	GBP: { key: 'gbp', value: localize('subscription-currency-gbp'), symbol: '£' },
	EUR: { key: 'eur', value: localize('subscription-currency-eur'), symbol: '€' }
};

export const CB_API_FETCH_CURRENCY = CURRENCIES.USD.key;

export const PLAN_CATEGORIES = {
	CLOUD_SUITE: 'Cloud Suite',
	CREATIVE_TOOLS: 'Creative Tools'
};

export const SUBSCRIPTION_PLAN = {
	PHOTO: 'photo',
	WEB: 'web',
	DESIGNER: 'designer',
	PHOTO_PERPETUAL: 'photol',
	WEB_PERPETUAL: 'webl',
	DESIGNER_PERPETUAL: 'designerl',

	ESSENTIAL: 'essential',
	SCALE: 'scale',
	ENTERPRISE: 'enterprise',

	TEAM_PLUS: 'teamplus'
};

export const PRODUCT_CATEGORY = {
	PHOTO: 'pgd',
	WEB: 'wd',
	DESIGNER: 'dp',
};

export const PERPETUAL_PRODUCT_CATEGORY = {
	PHOTO_PERPETUAL: 'pgd',
	WEB_PERPETUAL: 'wd',
	DESIGNER_PERPETUAL: 'dp',
};

/* COUPONS / DISCOUNTS */
export const COUPONS = {
	GET_COUPON_INFO: '/payment/chargebee/coupon'
};

export const PRODUCT_PREFIX_TO_PACKAGE_MAP = {
	XPS: SUBSCRIPTION_PLAN.DESIGNER,
	XWDS: SUBSCRIPTION_PLAN.WEB,
	PGDS: SUBSCRIPTION_PLAN.PHOTO,
	XPL: SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL,
	XWDL: SUBSCRIPTION_PLAN.WEB_PERPETUAL,
	XPGDL: SUBSCRIPTION_PLAN.PHOTO_PERPETUAL
};

export const PRODUCT_CATEGORY_TO_PACKAGE_MAP = {
	[PRODUCT_CATEGORY.DESIGNER]: SUBSCRIPTION_PLAN.DESIGNER,
	[PRODUCT_CATEGORY.WEB]: SUBSCRIPTION_PLAN.WEB,
	[PRODUCT_CATEGORY.PHOTO]: SUBSCRIPTION_PLAN.PHOTO,
};

export const PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP = {
	[PERPETUAL_PRODUCT_CATEGORY.DESIGNER_PERPETUAL]: SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL,
	[PERPETUAL_PRODUCT_CATEGORY.WEB_PERPETUAL]: SUBSCRIPTION_PLAN.WEB_PERPETUAL,
	[PERPETUAL_PRODUCT_CATEGORY.PHOTO_PERPETUAL]: SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
};

export const FALLBACK_COUPON = {
	SUBSCRIPTION: process.env.REACT_APP_SUBSCRIPTION_FALLBACK_COUPON_ID,
	PERPETUAL: process.env.REACT_APP_PERPETUAL_FALLBACK_COUPON_ID
};

export const DISCOUNT_KEY = {
	TIER1: 'tier_1', // expired or will expire in 0-6 months
	TIER2: 'tier_2', // expires in 6 month - 1 year
	TIER3: 'tier_3', // expires in more than 1 year (extended).
	UPGRADE_POPUP: 'upgrade_popup',
	PHOTOL: 'tier_pgd',
	WEBL: 'tier_wd',
	DESIGNERL: 'tier_dp'
};

export const DISCOUNT_TYPE = {
	MAGIX: 'magix',
	COUPON_SET_ID: 'coupon_set_id',
	COUPON_ID: 'coupon_id'
};

export const MAXIC_DISCOUNT_PROD_TYPE = {
	PERPETUAL: 'perpetual',
	SUBSCRIPTION: 'subscription'
};

export const PACKAGE_DESCRIPTION_ITEM_TYPE = {
	SECTION: 'section',
	ACCORDION: 'accordion'
};

export const DISCOUNTS_CONFIG = {
	/* magix discount for subscriptions */
	[DISCOUNT_KEY.TIER1]: {
		discount: process.env.REACT_APP_TIER1_DISCOUNT,
		coupon_set_id: process.env.REACT_APP_TIER1_COUPON_SET_ID
	},
	[DISCOUNT_KEY.TIER2]: {
		discount: process.env.REACT_APP_TIER2_DISCOUNT,
		coupon_set_id: process.env.REACT_APP_TIER2_COUPON_SET_ID
	},
	[DISCOUNT_KEY.TIER3]: {
		discount: process.env.REACT_APP_TIER3_DISCOUNT,
		coupon_set_id: process.env.REACT_APP_TIER3_COUPON_SET_ID
	},
	/* upgrade popup in XC */
	[DISCOUNT_KEY.UPGRADE_POPUP]: {
		discount: process.env.REACT_APP_UPGRADE_POPUP_DISCOUNT,
		coupon_set_id: process.env.REACT_APP_UPGRADE_POPUP_SET_ID
	},
	/* magix discount for perpetual */
	[DISCOUNT_KEY.PHOTOL]: {
		discount: process.env.REACT_APP_PHOTOL_DISCOUNT,
		coupon_set_id: process.env.REACT_APP_PHOTOL_COUPON_SET_ID
	},
	[DISCOUNT_KEY.WEBL]: {
		discount: process.env.REACT_APP_WEBL_DISCOUNT,
		coupon_set_id: process.env.REACT_APP_WEBL_COUPON_SET_ID
	},
	[DISCOUNT_KEY.DESIGNERL]: {
		discount: process.env.REACT_APP_DESIGNERL_DISCOUNT,
		coupon_set_id: process.env.REACT_APP_DESIGNERL_COUPON_SET_ID
	}
};

// Xara Cloud+ combines Xara Designer Pro+ (desktop product), with Xara Cloud (online editing)
export const SUBSCRIPTION_PLAN_UPGRADE_OPTIONS = {
	get [SUBSCRIPTION_PLAN.TEAM_PLUS]() {
		return [SUBSCRIPTION_PLAN.ENTERPRISE];
	},

	[SUBSCRIPTION_PLAN.ESSENTIAL]: [// Cloud only
		SUBSCRIPTION_PLAN.TEAM_PLUS, SUBSCRIPTION_PLAN.ENTERPRISE], 

	[SUBSCRIPTION_PLAN.SCALE]: [SUBSCRIPTION_PLAN.ENTERPRISE],// Cloud + Desktop
	[SUBSCRIPTION_PLAN.ENTERPRISE]: [],

	[SUBSCRIPTION_PLAN.WEB]: [// standalone desktop app
		SUBSCRIPTION_PLAN.DESIGNER,
		SUBSCRIPTION_PLAN.TEAM_PLUS,
		SUBSCRIPTION_PLAN.ENTERPRISE],

	[SUBSCRIPTION_PLAN.PHOTO]: [// standalone desktop app
		SUBSCRIPTION_PLAN.DESIGNER,
		SUBSCRIPTION_PLAN.TEAM_PLUS,
		SUBSCRIPTION_PLAN.ENTERPRISE],

	[SUBSCRIPTION_PLAN.DESIGNER]: [// standalone desktop app
		SUBSCRIPTION_PLAN.TEAM_PLUS,
		SUBSCRIPTION_PLAN.ENTERPRISE],
};

export const PHOTO_PERPETUAL_LATEST_VERSION = 20;
export const WEB_PERPETUAL_LATEST_VERSION = 20;
export const DESIGNER_PERPETUAL_LATEST_VERSION = 20;

export const MAP_ADDON_TO_LATEST_VERSION = {
	[SUBSCRIPTION_PLAN.WEB_PERPETUAL]: `webl_${WEB_PERPETUAL_LATEST_VERSION}`,
	[SUBSCRIPTION_PLAN.PHOTO_PERPETUAL]: `photol_${PHOTO_PERPETUAL_LATEST_VERSION}`,
	[SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL]: `designerl_${DESIGNER_PERPETUAL_LATEST_VERSION}`
};

export const SUBSCRIPTION_PERIOD = {
	MONTHLY: 'monthly',
	ANNUAL: 'annual',
	PERPETUAL: 'per'
};

export const MEMBER_ADDONS_DISCOUNT_DESKTOP_PLUS = 0.6;

export const SUBSCRIPTION_PRICES = {
	/* used only for GA4 tracking purposes */
	get [SUBSCRIPTION_PLAN.TEAM_PLUS]() {
		return this[SUBSCRIPTION_PLAN.SCALE];
	},

	[SUBSCRIPTION_PLAN.ESSENTIAL]: {
		[SUBSCRIPTION_PERIOD.MONTHLY]: 16.80,
		[SUBSCRIPTION_PERIOD.ANNUAL]: 12.00
	},
	[SUBSCRIPTION_PLAN.SCALE]: {
		[SUBSCRIPTION_PERIOD.MONTHLY]: 28.00,
		[SUBSCRIPTION_PERIOD.ANNUAL]: 20.00
	},

	/* 22.0 Release */
	[SUBSCRIPTION_PLAN.PHOTO]: {
		[SUBSCRIPTION_PERIOD.MONTHLY]: 9.00,
		[SUBSCRIPTION_PERIOD.ANNUAL]: 6.00
	},
	[SUBSCRIPTION_PLAN.WEB]: {
		[SUBSCRIPTION_PERIOD.MONTHLY]: 17.00,
		[SUBSCRIPTION_PERIOD.ANNUAL]: 12.00
	},
	[SUBSCRIPTION_PLAN.DESIGNER]: {
		[SUBSCRIPTION_PERIOD.MONTHLY]: 22.00,
		[SUBSCRIPTION_PERIOD.ANNUAL]: 16.00
	},

	/* 23.1 Release */
	[SUBSCRIPTION_PLAN.WEB_PERPETUAL]: {
		[SUBSCRIPTION_PERIOD.PERPETUAL]: 199.00,
	},
	[SUBSCRIPTION_PLAN.PHOTO_PERPETUAL]: {
		[SUBSCRIPTION_PERIOD.PERPETUAL]: 119.00,
	},
	[SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL]: {
		[SUBSCRIPTION_PERIOD.PERPETUAL]: 299.00,
	}
};

export const PACKAGES_CONFIG = {
	get [SUBSCRIPTION_PLAN.TEAM_PLUS]() {
		return {
			...this[SUBSCRIPTION_PLAN.SCALE],
			proxy: true
		};
	},

	[SUBSCRIPTION_PLAN.ESSENTIAL]: {
		className: 'essentialBox',
		title: 'Essential',
		description: localize('subscription-plan-essential-description'),
		optionsTitle: localize('subscription-plan-essential-options-title'),
		optionsTitleActive: localize('subscription-plan-essential-options-title-active'),

		membersIncludedInfo: [
			{
				label: localize('subscription-plan-essential-includes-1'),
				tooltip: localize('subscription-plan-essential-includes-1-tooltip')
			},
			{
				label: localize('subscription-plan-essential-includes-2'),
				rolesTooltip: true
			},
		],

		featuresListAdvanced: [
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-essential-bullet-brand-kit-title'),
				id: 'subscription-plan-essential-bullet-brand-kit-title',
				description: localize('subscription-plan-essential-bullet-brand-kit-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-essential-bullet-document-resizing-title'),
				id: 'subscription-plan-essential-bullet-document-resizing-title',
				description: localize('subscription-plan-essential-bullet-document-resizing-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-essential-bullet-social-media-title'),
				id: 'subscription-plan-essential-bullet-social-media-title',
				description: localize('subscription-plan-essential-bullet-social-media-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-essential-bullet-ai-title'),
				id: 'subscription-plan-essential-bullet-ai-title',
				description: localize('subscription-plan-essential-bullet-ai-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-essential-bullet-shared-assets-title'),
				id: 'subscription-plan-essential-bullet-shared-assets-title',
				description: localize('subscription-plan-essential-bullet-shared-assets-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-essential-bullet-import-export-title'),
				id: 'subscription-plan-essential-bullet-import-export-title',
				description: localize('subscription-plan-essential-bullet-import-export-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-essential-bullet-try-for-free-title'),
				id: 'subscription-plan-essential-bullet-try-for-free-title',
				highlighted: true,
				tag: localize('subscription-plan-tag-new'),
				description: localize('subscription-plan-essential-bullet-try-for-free-description')
			}
		],
		isPlusPackage: false,
		isCloudSuitePlan: true,
		isCreativeToolsPlan: false,
		isPerpetual: false,
		isMultiUser: true,
		freeSeatsIncluded: 3,
		isEmptySeatsAllowed: true,
		icon: IconEssential,
		isCloudTag: true,
		isDesktopTag: false,
		order: 4,
		selectedAddons: {
			membersess: {
				isRecurring: true,
				isObsolete: false
			}
		}
	},

	[SUBSCRIPTION_PLAN.SCALE]: {
		className: 'scaleBox',
		title: 'Scale',
		description: localize('subscription-plan-scale-description'),
		descriptionDesktop: localize('subscription-plan-scale-description-desktop'),
		optionsTitle: localize('subscription-plan-scale-options-title'),
		optionsTitleDesktop: localize('subscription-plan-scale-options-title-desktop'),

		membersIncludedInfo: [
			{
				label: localize('subscription-plan-scale-includes-1'),
				tooltip: localize('subscription-plan-scale-includes-1-tooltip')
			},
			{
				label: localize('subscription-plan-scale-includes-2'),
				rolesTooltip: true
			}
		],

		featuresListMain: [
			{label: localize('subscription-plan-scale-list-main-1')},
			{label: localize('subscription-plan-scale-list-main-2')},
			{label: localize('subscription-plan-scale-list-main-3')},
			{label: localize('subscription-plan-scale-list-main-4')},
			{label: localize('subscription-plan-scale-list-main-5')},
			{label: localize('subscription-plan-scale-list-main-6')}
		],

		featuresListAdvanced: [
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,
				label: localize('subscription-plan-scale-section-ai-title'),
				id: 'subscription-plan-scale-section-ai-title',
				description: localize('subscription-plan-scale-section-ai-description'),
				tag: localize('subscription-plan-tag-new'),

				bullets: [
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-ai-writter-title'),
						id: 'subscription-plan-scale-bullet-ai-writter-title',
						description: localize('subscription-plan-scale-bullet-ai-writter-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-ai-translator-title'),
						id: 'subscription-plan-scale-bullet-ai-translator-title',
						description: localize('subscription-plan-scale-bullet-ai-translator-description')
					},
				] 
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,
				label: localize('subscription-plan-scale-section-marketing-title'),
				id: 'subscription-plan-scale-section-marketing-title',
				bullets: [
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-document-creation-title'),
						id: 'subscription-plan-scale-bullet-document-creation-title',
						description: localize('subscription-plan-scale-bullet-document-creation-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-playbook-title'),
						id: 'subscription-plan-scale-bullet-playbook-title',
						description: localize('subscription-plan-scale-bullet-playbook-description'),
						tag: localize('subscription-plan-tag-coming-soon')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-content-personalization-title'),
						id: 'subscription-plan-scale-bullet-content-personalization-title',
						description: localize('subscription-plan-scale-bullet-content-personalization-description')
					}
				] 
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,
				label: localize('subscription-plan-scale-section-collaborate-title'),
				id: 'subscription-plan-scale-section-collaborate-title',
				bullets: [
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						id: 'subscription-plan-scale-bullet-library-title',
						label: localize('subscription-plan-scale-bullet-library-title'),
						description: localize('subscription-plan-scale-bullet-library-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-template-modification-title'),
						id: 'subscription-plan-scale-bullet-template-modification-title',
						description: localize('subscription-plan-scale-bullet-template-modification-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-user-roles-title'),
						id: 'subscription-plan-scale-bullet-user-roles-title',
						description: localize('subscription-plan-scale-bullet-user-roles-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-member-access-title'),
						id: 'subscription-plan-scale-bullet-member-access-title',
						description: localize('subscription-plan-scale-bullet-member-access-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-approved-media-title'),
						id: 'subscription-plan-scale-bullet-approved-media-title',
						description: localize('subscription-plan-scale-bullet-approved-media-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-approved-templates-title'),
						id: 'subscription-plan-scale-bullet-approved-templates-title',
						description: localize('subscription-plan-scale-bullet-approved-templates-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-analytics-title'),
						id: 'subscription-plan-scale-bullet-analytics-title',
						description: localize('subscription-plan-scale-bullet-analytics-description')
					}
				] 
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,
				label: localize('subscription-plan-scale-section-content-assistance-title'),
				id: 'subscription-plan-scale-section-content-assistance-title',
				bullets: [
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-scale-bullet-curated-library-title'),
						id: 'subscription-plan-scale-bullet-curated-library-title',
						description: localize('subscription-plan-scale-bullet-curated-library-description'),
						tag: localize('subscription-plan-tag-new')
					}
				]
			}
		],
		
		isPlusPackage: false,/* temporarily disable */
		isCloudSuitePlan: true,
		isCreativeToolsPlan: false,/* temporarily disable */
		isPerpetual: false,
		isMultiUser: true,
		isEmptySeatsAllowed: true,
		freeSeatsIncluded: 3,
		icon: IconScale,
		isCloudTag: true,
		isDesktopTag: true,
		customPackageTag: localize('subscription-plan-scale-tag'),
		order: 5,
		selectedAddons: {
			membersplus: {
				isRecurring: true,
				isObsolete: false
			},
			members: {
				isRecurring: true,
				isObsolete: true
			}
		} 
	},

	[SUBSCRIPTION_PLAN.ENTERPRISE]: {
		className: 'enterpriseBox',
		title: 'Enterprise',
		description: localize('subscription-plan-enterprise-description'),
		optionsTitle: localize('subscription-plan-enterprise-options-title'),

		featuresListAdvanced: [
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-enterprise-bullet-flexible-pricing-title'),
				id: 'subscription-plan-enterprise-bullet-flexible-pricing-title',
				description: localize('subscription-plan-enterprise-bullet-flexible-pricing-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-enterprise-bullet-unlimited-storage-title'),
				id: 'subscription-plan-enterprise-bullet-unlimited-storage-title',
				description: localize('subscription-plan-enterprise-bullet-unlimited-storage-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-enterprise-bullet-sso-title'),
				id: 'subscription-plan-enterprise-bullet-sso-title',
				description: localize('subscription-plan-enterprise-bullet-sso-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-enterprise-bullet-custom-integration-title'),
				id: 'subscription-plan-enterprise-bullet-custom-integration-title',
				description: localize('subscription-plan-enterprise-bullet-custom-integration-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-enterprise-bullet-multi-team-title'),
				id: 'subscription-plan-enterprise-bullet-multi-team-title',
				description: localize('subscription-plan-enterprise-bullet-multi-team-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-enterprise-bullet-api-title'),
				id: 'subscription-plan-enterprise-bullet-api-title',
				description: localize('subscription-plan-enterprise-bullet-api-description')
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
				label: localize('subscription-plan-enterprise-bullet-playbooks-title'),
				id: 'subscription-plan-enterprise-bullet-playbooks-title',
				description: localize('subscription-plan-enterprise-bullet-playbooks-description'),
				tag: localize('subscription-plan-tag-coming-soon')
			},		
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,
				label: localize('subscription-plan-enterprise-section-self-service-title'),
				id: 'subscription-plan-enterprise-section-self-service-title',
				bullets: [
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-enterprise-bullet-campaign-posting-title'),
						id: 'subscription-plan-enterprise-bullet-campaign-posting-title',
						description: localize('subscription-plan-enterprise-bullet-campaign-posting-description'),
						tag: localize('subscription-plan-tag-new')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-enterprise-bullet-community-campaigns-title'),
						id: 'subscription-plan-enterprise-bullet-community-campaigns-title',
						description: localize('subscription-plan-enterprise-bullet-community-campaigns-description')
					}													
				] 
			},
			{
				type: PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,
				label: localize('subscription-plan-enterprise-section-template-assistance-title'),
				id: 'subscription-plan-enterprise-section-template-assistance-title',
				bullets: [
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-enterprise-bullet-library-setup-title'),
						id: 'subscription-plan-enterprise-bullet-library-setup-title',
						description: localize('subscription-plan-enterprise-bullet-library-setup-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-enterprise-bullet-template-updates-title'),
						id: 'subscription-plan-enterprise-bullet-template-updates-title',
						description: localize('subscription-plan-enterprise-bullet-template-updates-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-enterprise-bullet-strategy-definition-title'),
						id: 'subscription-plan-enterprise-bullet-strategy-definition-title',
						description: localize('subscription-plan-enterprise-bullet-strategy-definition-description')
					},
					{
						type: PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,
						label: localize('subscription-plan-enterprise-bullet-personalized-training-title'),
						id: 'subscription-plan-enterprise-bullet-personalized-training-title',
						description: localize('subscription-plan-enterprise-bullet-personalized-training-description')
					}
				] 
			}
		],
		order: 6,
		icon: IconScale,
		isPlusPackage: false,
		isCloudSuitePlan: true,
		isCreativeToolsPlan: false,
		isPerpetual: false,
		isCloudTag: true,
		isDesktopTag: true,
		doesNotExistInCB: true
	},

	[SUBSCRIPTION_PLAN.WEB]: {/* standalone desktop app (subscription) */
		className: 'webBox',
		title: 'Web<br> Designer+',
		description: localize('subscription-plan-web-description'),
		per_user: localize('subscription-plan-web-includes'),
		optionsTitle: localize('subscription-plan-web-options-title'),
		featuresListMain: [
			{label: localize('subscription-plan-web-list-main-1')},
			{label: localize('subscription-plan-web-list-main-2')},
			{label: localize('subscription-plan-web-list-main-3')},
			{label: localize('subscription-plan-web-list-main-4')},
			{label: localize('subscription-plan-web-list-main-5')},
			{label: localize('subscription-plan-web-list-main-6')},
			{label: localize('subscription-plan-web-list-main-7')},
			{label: localize('subscription-plan-web-list-main-8')},
			{label: localize('subscription-ovhcloud-discount')}
		],
		isPlusPackage: true,
		isCloudSuitePlan: false,
		isCreativeToolsPlan: true,
		isPerpetual: false,
		isMultiUser: true,
		freeSeatsIncluded: 1,
		isEmptySeatsAllowed: true,
		icon: IconWD,
		isCloudTag: false,
		isDesktopTag: true,
		order: 2,
		selectedAddons: {
			membersweb: {
				isRecurring: true,
				isObsolete: false
			}
		}
	},

	[SUBSCRIPTION_PLAN.PHOTO]: {/* standalone desktop app (subscription) */
		className: 'photoBox',
		title: 'Photo &<br> Graphic Designer+',

		description: localize('subscription-plan-photo-description'),
		per_user: localize('subscription-plan-photo-includes'),
		optionsTitle: localize('subscription-plan-photo-options-title'),
		featuresListMain: [
			{label: localize('subscription-plan-photo-list-main-1')},
			{label: localize('subscription-plan-photo-list-main-2')},
			{label: localize('subscription-plan-photo-list-main-3')},
			{label: localize('subscription-plan-photo-list-main-4')},			
			{label: localize('subscription-plan-photo-list-main-5')},
			{label: localize('subscription-plan-photo-list-main-6')},
			{label: localize('subscription-plan-photo-list-main-7')},
			{label: localize('subscription-plan-photo-list-main-8')}
		],
		isPlusPackage: true,
		isCloudSuitePlan: false,
		isCreativeToolsPlan: true,
		isPerpetual: false,
		isMultiUser: true,
		freeSeatsIncluded: 1,
		isEmptySeatsAllowed: true,
		icon: IconPGD,
		isCloudTag: false,
		isDesktopTag: true,
		order: 1,
		selectedAddons: {
			membersphoto: {
				isRecurring: true,
				isObsolete: false
			}
		}
	},

	[SUBSCRIPTION_PLAN.DESIGNER]: {/* standalone desktop app (subscription) */
		className: 'designerBox',
		title: 'Designer Pro+',

		description: localize('subscription-plan-designer-description'),
		per_user: localize('subscription-plan-designer-includes'),
		optionsTitle: localize('subscription-plan-designer-options-title'),
		featuresListMain: [
			{label: localize('subscription-plan-designer-list-main-1')},
			{label: localize('subscription-plan-designer-list-main-2')},
			{label: localize('subscription-plan-designer-list-main-3')},
			{label: localize('subscription-plan-designer-list-main-4')},			
			{label: localize('subscription-plan-designer-list-main-5')},
			{label: localize('subscription-plan-designer-list-main-6')},
			{label: localize('subscription-plan-designer-list-main-7')},
			{label: localize('subscription-plan-designer-list-main-8')},
			{label: localize('subscription-ovhcloud-discount')}
		],
		isPlusPackage: true,
		isCloudSuitePlan: false,
		isCreativeToolsPlan: true,
		isPerpetual: false,
		isMultiUser: true,
		freeSeatsIncluded: 1,
		isEmptySeatsAllowed: true,
		icon: IconDP,
		isCloudTag: false,
		isDesktopTag: true,
		order: 3,
		selectedAddons: {
			membersdes: {
				isRecurring: true,
				isObsolete: false
			}
		}
	},

	[SUBSCRIPTION_PLAN.WEB_PERPETUAL]: {/* standalone desktop app (perpetual) */
		className: 'webBox',
		title: 'Web<br> Designer v_VERSION_',
		description: localize('subscription-plan-web-per-description'),
		per_user: localize('subscription-plan-web-per-includes'),
		featuresListMain: [
			{label: localize('subscription-plan-web-per-list-main-1')},
			{label: localize('subscription-plan-web-per-list-main-2')},
			{label: localize('subscription-plan-web-per-list-main-3')},
			{label: localize('subscription-plan-web-per-list-main-4'), excluded: true},			
			{label: localize('subscription-plan-web-per-list-main-5')},
			{label: localize('subscription-ovhcloud-discount')}
		],
		isPlusPackage: false,
		isCloudSuitePlan: false,
		isCreativeToolsPlan: true,
		isPerpetual: true,
		icon: IconWDPerpetual,
		isEmptySeatsAllowed: false,
		isAddon: true,
		order: 2,
	},

	[SUBSCRIPTION_PLAN.PHOTO_PERPETUAL]: {/* standalone desktop app (perpetual) */
		className: 'photoBox',
		title: 'Photo & Graphic<br> Designer v_VERSION_',
		description: localize('subscription-plan-photo-per-description'),
		per_user: localize('subscription-plan-photo-per-includes'),

		featuresListMain: [
			{label: localize('subscription-plan-photo-per-list-main-1')},
			{label: localize('subscription-plan-photo-per-list-main-2')},
			{label: localize('subscription-plan-photo-per-list-main-3')},
			{label: localize('subscription-plan-photo-per-list-main-4'), excluded: true},			
			{label: localize('subscription-plan-photo-per-list-main-5')}
		],
		isPlusPackage: false,
		isCloudSuitePlan: false,
		isCreativeToolsPlan: true,
		isPerpetual: true,
		icon: IconPGDPerpetual,
		isEmptySeatsAllowed: false,
		isAddon: true,
		order: 1
	},
	[SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL]: {/* standalone desktop app (perpetual) */
		className: 'designerBox',
		title: 'Designer Pro v_VERSION_',
		description: localize('subscription-plan-designer-per-description'),
		per_user: localize('subscription-plan-designer-per-includes'),
		featuresListMain: [
			{label: localize('subscription-plan-designer-per-list-main-1')},
			{label: localize('subscription-plan-designer-per-list-main-2')},
			{label: localize('subscription-plan-designer-per-list-main-3')},
			{label: localize('subscription-plan-designer-per-list-main-4')},			
			{label: localize('subscription-plan-designer-per-list-main-5'), excluded: true},			
			{label: localize('subscription-plan-designer-per-list-main-6')},
			{label: localize('subscription-ovhcloud-discount')}
		],
		isPlusPackage: false,
		isCloudSuitePlan: false,
		isCreativeToolsPlan: true,
		isPerpetual: true,
		icon: IconDPPerpetual,
		isEmptySeatsAllowed: false,
		isAddon: true,
		order: 3
	}
};

export const getCloudPlans = () => {
	const keys = Object.keys(PACKAGES_CONFIG);
	const result = [];
	keys.forEach(key => {
		if (PACKAGES_CONFIG[key].isCloudSuitePlan) {
			result.push(key);
		}
	});
	return result;
};

export const getMemberAddonsIds = () => {
	const keys = Object.keys(_.omitBy(PACKAGES_CONFIG, (item) => Boolean(item.proxy)));
	const result = [];
	keys.forEach(packageKey => {
		const selectedAddons = PACKAGES_CONFIG[packageKey].selectedAddons;
		if (selectedAddons) {
			result.push(...Object.keys(selectedAddons));
		}
	});
	return result;
};

export const DEFAULT_SUBSCRIPTION = {
	plan: undefined,
	period: SUBSCRIPTION_PERIOD.ANNUAL,
	currency: CURRENCIES.USD.key
};

export const CHARGEBEE_SITE_URL = process.env.REACT_APP_CHARGEBEE_SITE_URL;
export const CHARGEBEE_ENABLE_GA_TRACKING = process.env.REACT_APP_CHARGEBEE_ENABLE_GA_TRACKING;
export const CHARGEBEE_ENABLE_REFERSION_TRACKING = process.env.REACT_APP_CHARGEBEE_ENABLE_REFERSION_TRACKING;

export const SUBSCRIPTION_KEY = 'subscription'; // used as a key to store CAP settings
export const CAP_KEY = 'cap'; // used as a key to store CAP settings
export const ONBOARDING_KEY = 'onboarding'; // used as a key to store the onboarding state in user settings
// used as a key to store designer pro download data in user settings
export const USER_DOWNLOAD_NOTIFICATION_SETTING_KEY = 'tms:download-notification';
export const USER_DISCOUNT_BANNER_SETTING_KEY = 'discount-banner';
export const FOREVER_HIDDEN_KEY = 'forever-hidden';
export const USER_PAGE_SETTINGS_KEY = 'user-page-settings';

export const FONTS_ACCEPTED_FILE_TYPES = ['.ttf', '.otf']; // allowed font extensions

export const STATIC_RESOURCE_INDUSTRIES_PATH = '/json/companyindustries';
export const STATIC_RESOURCE_COUNTRIES_PATH = '/json/companycountries';
export const STATIC_RESOURCE_SIZES_PATH = '/json/companysizes';

export const apiStatus = {
	url: process.env.REACT_APP_API_STATUS_URL,
	timeout: 30000, // 30s
	status: {
		ONLINE: 1,
		OFFLINE: 4,
		MAINTENANCE: 3
	},
	endpoint: {
		'camlinux4': 6,
		'camlinux2': 8,
		'camlinux5': 10,
		'ec2linuxstaging': 4,
		'pre-prod-mw': 4,
		'elb': 2,
		'prod-mw': 2
	}
};

export const DESKTOP_APPS = {
	DESIGNER: {
		title: 'Designer Pro+',
		downloadUrl: 'https://xpsupdater.xara.com/Installer/XPSSetup.exe',
		detailsUrl: 'https://www.xara.com/designerpro-plus/',
		storageKey: 'designerProDownloads',// keep this name for backward compatibility with XC client
		trackingKey: 'pro-plus',// keep this name for backward compatibility with XC client
		isPerpetual: false
	},
	WEB: {
		title: 'Web Designer+',
		downloadUrl: 'https://xpsupdater.xara.com/Installer/XWDSSetup.exe',
		detailsUrl: 'https://www.xara.com/webdesigner-plus/',
		storageKey: 'WDPlusDownloads',
		trackingKey: 'wd-plus',
		isPerpetual: false
	},
	PHOTO: {
		title: 'Photo & Graphic Designer+',
		downloadUrl: 'https://xpsupdater.xara.com/Installer/PGDSSetup.exe',
		detailsUrl: 'https://www.xara.com/photo-graphic-plus/',
		storageKey: 'PGDPlusDownloads',
		trackingKey: 'pgd-plus',
		isPerpetual: false
	},
	DESIGNERL: {
		title: 'Designer Pro v_VERSION_',
		downloadUrl: 'https://xpsupdater.xara.com/Installer/XPL_VERSION_Setup.exe',
		storageKey: 'designerProPerpetualDownloads',// keep this name for backward compatibility with XC client
		trackingKey: 'pro-perpetual',// keep this name for backward compatibility with XC client
		isPerpetual: true
	},
	WEBL: {
		title: 'Web Designer v_VERSION_',
		downloadUrl: 'https://xpsupdater.xara.com/Installer/XWDL_VERSION_Setup.exe',
		storageKey: 'WDPerpetualDownloads',
		trackingKey: 'wd-perpetual',
		isPerpetual: true
	},
	PHOTOL: {
		title: 'Photo & Graphic Designer v_VERSION_',
		downloadUrl: 'https://xpsupdater.xara.com/Installer/XPGDL_VERSION_Setup.exe',
		storageKey: 'PGDPerpetualDownloads',
		trackingKey: 'pgd-perpetual',
		isPerpetual: true
	},
};

export const TEMPORARY_COMPANY_PREFIX = 'tempcomp_';

export const loggerConfig = {
	errorHistoryStorageKey: 'cfg.logger.errorHistory',
	errorQueueStorageKey: 'cfg.logger.errorQueue',
	endpoint: process.env.REACT_APP_LOGGER_ENDPOINT || 'https://logs.xara.com:5010' /* cl2 */,
	sendFromDev: process.env.REACT_APP_LOGGER_SEND_FROM_DEV || false
};

export const REACT_APP_BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || 'not available';
export const REACT_APP_BRANCH = process.env.REACT_APP_BRANCH || 'not available';
export const REACT_APP_BUILD_VCS_NUMBER = process.env.REACT_APP_BUILD_VCS_NUMBER || 'not available';

export const SERIAL_NUMBER_REGEXP = new RegExp(/^[\w-]+$/);

export const USER_TABLE_ALL = 'users_all';
export const USER_TABLE_ADMINS_AND_MEMBERS = 'admins_and_members';
export const USER_TABLE_GUESTS = 'guest';
export const USER_TABLE_REDUCE_USERS = 'reduce_users';

export const USER_TABLES = {
	[USER_TABLE_ADMINS_AND_MEMBERS]: {
		label: localize('users-table-header-admins-and-members')
	},
	[USER_TABLE_GUESTS]: {
		label: localize('users-table-header-guests')
	}
};

export const TABLE_COLUMNS = {
	FULL_NAME: 'full_name',
	EMAIL: 'email',
	ROLE: 'role',
	MLS_ID: 'mls_id'
};

export const SORT_ORDER = {
	ASC: 'ascending',
	DESC: 'descending'
};

export const SUBSCRIPTION_VIEW = {
	CURRENT_PRODUCTS: localize('subscription-your-products-tab'),
	PURCHASE_OPTIONS: localize('subscription-purchase-options-tab')
};

export const SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS = ['X3D', 'X32', 'XXP', 'XX2', 'XXA', 'XWS', 'XMM'];
export const SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS = ['P', 'P2', 'P3', 'S2'];

export const BUY_MORE_POPUP_TYPE = {
	SEATS: 'seats',
	LICENSES: 'licenses'
};

export const QUANTITY_TYPE = {
	SEATS: 'seats',
	LICENSES: 'licenses'
};


export const COUPON_TYPE = {
	SEATS: 'seats',
	LICENSES: 'licenses'
};

export const REDUCE_ACTION = {
	KEEP_ROLE: 'keep-role',
	CHANGE_TO_GUEST: 'change-to-guest',
	REMOVE: 'remove'
};

export const ADDON_TYPE = {
	PERPETUAL: 'perpetual',
	MEMBER: 'member'
};

export const ADDONS_LIST = {
	AI: 'ai',
	CLOUD_STORAGE: 'cloud_storage',
	MLS: 'mls',
	DESIGN_SERVICES: 'design_services',
	HOSTING: 'hosting'
};

export const ADDONS_CONFIG = {
	[ADDONS_LIST.AI]: {
		title: localize('addon-ai-title'),
		icon: IconAddonAI,
		description: localize('addon-ai-description'),
		details: 'addon-ai-details',

		featuresList: [
			{label: localize('addon-ai-details-list-1')},
			{label: localize('addon-ai-details-list-2')},
			{label: localize('addon-ai-details-list-3')},
			{label: localize('addon-ai-details-list-4')},
			{label: localize('addon-ai-details-list-5')}
		],

		featuresNote: localize('addon-ai-details-list-note'),
		buttonLabel: localize('subscription-contact-sales'),
		intercomMessage: localize('addon-intercom-message-ai'),
		isCloudAddon: true,
		isDesktopAddon: false
	},

	[ADDONS_LIST.CLOUD_STORAGE]: {
		title: localize('addon-cloud-storage-title'),
		icon: IconAddonCloudStorage,
		description: localize('addon-cloud-storage-description'),
		details: 'addon-cloud-storage-details',
		buttonLabel: localize('subscription-contact-sales'),
		intercomMessage: localize('addon-intercom-message-cloud-storage'),
		isCloudAddon: true,
		isDesktopAddon: false
	},

	[ADDONS_LIST.MLS]: {
		title: localize('addon-mls-title'),
		icon: IconAddonMLS,
		description: localize('addon-mls-description'),
		details: 'addon-mls-details',
		tag: localize('addon-mls-tag'),
		buttonLabel: localize('subscription-contact-sales'),
		intercomMessage: localize('addon-intercom-message-mls'),
		isCloudAddon: true,
		isDesktopAddon: false
	},

	[ADDONS_LIST.DESIGN_SERVICES]: {
		title: localize('addon-design-service-title'),
		icon: IconAddonDesignServices,
		description: localize('addon-design-service-description'),
		details: 'addon-design-service-details',
		tag: localize('addon-design-service-tag'),
		buttonLabel: localize('subscription-get-a-quote'),
		intercomMessage: localize('addon-intercom-message-design-services'),
		isCloudAddon: true,
		isDesktopAddon: false
	},

	[ADDONS_LIST.HOSTING]: {
		title: localize('addon-hosting-title'),
		icon: IconAddonHosting,
		description: localize('addon-hosting-description'),

		featuresList: [
			{label: localize('addon-hosting-details-list-1')},
			{label: localize('addon-hosting-details-list-2')},
			{label: localize('addon-hosting-details-list-3')}
		],

		tagSubscription: localize('addon-hosting-details-subscription'),
		tagPerpetual: localize('addon-hosting-details-perpetual'),
		buttonLabel: localize('addon-hosting-button-label'),
		buttonURL: HOSTING_BUTTON_URL_EN,
		isCloudAddon: false,
		isDesktopAddon: true
	}	
};

export const ENABLE_MLS_ID_FIELD_FOR_INDUSTRIES = [1 /* real estate */];
export const ENABLE_MLS_ID_FIELD_FOR_REGION = ['US', 'CA'];




// WEBPACK FOOTER //
// ./src/config.js